import React from "react";
import Routess from "./Routess";

import "bootstrap/dist/css/bootstrap.min.css";
import 'react-loading-skeleton/dist/skeleton.css';

function App() {
    // console.log("TESTING2")
    // console.log(process?.env?.REACT_APP_NODE_ENV)
    // console.log(process?.env?.NODE_ENV)
    // console.log(process?.env?.TEST)

  return (
    <div id="parent-container">
      <Routess />
    </div>
  );
}

export default App;
